import React from "react";

export const Button = ({ children, variant = "default", className, onClick }) => {
  return (
    <button className={className} onClick={onClick}>
      {children}
    </button>
  );
};